module.exports = __webpack_public_path__ + "static/media/10.fb59ac33.jpg";